const fr = {
  contact: {
    heroHeading: 'Contactez-nous',
    heroSub: 'Que vous achetiez, vendiez ou investissiez \u2014 notre \u00e9quipe est l\u00e0 pour vous accompagner \u00e0 chaque \u00e9tape.',
    expertsBadge: 'Rencontrez nos experts',
    expertsHeading: 'Les personnes derri\u00e8re Victory Homes',
    officeLabel: 'Adresse du bureau',
    phoneLabel: 'Num\u00e9ros de t\u00e9l\u00e9phone',
    phoneOffice: 'Bureau',
    phoneWA: 'Appel / WhatsApp',
    emailLabel: 'Nous \u00e9crire',
    followLabel: 'Suivez-nous',
    formHeading: 'Envoyez-nous un message',
    formSub: 'Remplissez le formulaire ci-dessous et notre \u00e9quipe vous r\u00e9pondra dans les 24 heures.',
    fieldName: 'Votre nom *',
    fieldEmail: 'Adresse e-mail *',
    fieldPhone: 'Num\u00e9ro de t\u00e9l\u00e9phone',
    fieldSubject: 'Objet',
    fieldMessage: 'Votre message *',
    sendBtn: 'Envoyer le message',
    sentBtn: '\u2713 Message envoy\u00e9\u00a0!',
    thankYou: 'Merci\u00a0! Nous vous r\u00e9pondrons dans les 24 heures.',
  },
  mort: {
    heroBadge: 'Services hypoth\u00e9caires',
    heroLine1: 'Solutions hypoth\u00e9caires aux \u00c9AE',
    heroAccent: 'Taill\u00e9es pour vous',
    heroSub: 'Calculez votre mensualit\u00e9, v\u00e9rifiez votre \u00e9ligibilit\u00e9 et explorez les offres de plus de 15 banques des \u00c9AE \u2014 tout en un seul endroit.',
    tabCalc: '\ud83d\udcca Calculatrice hypoth\u00e9caire',
    tabElig: '\u2705 V\u00e9rification d\u2019\u00e9ligibilit\u00e9',
    loanParams: 'Param\u00e8tres du pr\u00eat',
    propertyValue: 'Valeur du bien',
    downPayment: 'Apport initial',
    annualRate: 'Taux d\u2019int\u00e9r\u00eat annuel',
    loanTenure: 'Dur\u00e9e du pr\u00eat',
    years: (n) => `${n} ans`,
    minDown: '20\u00a0% (min.)',
    maxUAE: '25 ans (max. \u00c9AE)',
    monthlyEMI: 'Mensualit\u00e9',
    loanAmount: 'Montant du pr\u00eat',
    totalInterest: 'Total int\u00e9r\u00eats',
    totalPayable: 'Total \u00e0 rembourser',
    principalVsInterest: 'Capital vs Int\u00e9r\u00eats',
    principal: 'Capital',
    interest: 'Int\u00e9r\u00eats',
    compareRates: '\ud83c\udfe6 Comparer les taux des banques des \u00c9AE',
    amortSchedule: '\ud83d\udcc5 Tableau d\u2019amortissement annuel',
    basedOnLoan: (amt, yrs) => `Sur la base d\u2019un pr\u00eat de AED\u00a0${amt} sur ${yrs}\u00a0ans. Taux indicatifs \u2014 contactez-nous pour des devis en direct.`,
    bankCol: 'Banque',
    fixedRate3yr: 'Taux fixe (3\u00a0ans)',
    variableEIBOR: 'Variable (EIBOR+)',
    monthlyEMIFixed: 'Mensualit\u00e9 (fixe)',
    totalCost: 'Co\u00fbt total',
    eibor3mNote: (rate) => `* EIBOR 3\u00a0M\u00a0: ${rate}\u00a0% (taux de r\u00e9f\u00e9rence). Les taux variables sont r\u00e9vis\u00e9s p\u00e9riodiquement.`,
    yearCol: 'Ann\u00e9e',
    principalPaid: 'Capital rembours\u00e9',
    interestPaid: 'Int\u00e9r\u00eats pay\u00e9s',
    balanceRemaining: 'Capital restant',
    yearRow: (n) => `Ann\u00e9e ${n}`,
    financialProfile: 'Votre profil financier',
    residencyStatus: 'Statut de r\u00e9sidence',
    residencyOpts: [
      { value: 'resident',    label: '\ud83c\udfe0 R\u00e9sident \u00c9AE',   desc: '80\u00a0% LTV \u00b7 25\u00a0ans max' },
      { value: 'national',    label: '\ud83c\udde6\ud83c\uddea National \u00c9AE',  desc: '85\u00a0% LTV \u00b7 25\u00a0ans max' },
      { value: 'nonresident', label: '\u2708\ufe0f Non-r\u00e9sident',  desc: '50\u00a0% LTV \u00b7 15\u00a0ans max' },
    ],
    yourAge: 'Votre \u00e2ge',
    ageUnit: 'ans',
    monthlySalary: 'Salaire mensuel (AED)',
    otherIncome: 'Autres revenus mensuels',
    existingEMI: 'Mensualit\u00e9s de pr\u00eats existants (AED/mois)',
    creditCard: 'Plafond carte de cr\u00e9dit (AED)',
    ccNote: 'Les banques comptent 5\u00a0% du plafond comme charge mensuelle',
    assumedRate: 'Taux d\u2019int\u00e9r\u00eat suppos\u00e9',
    checkBtn: '\ud83d\udd0d V\u00e9rifier mon \u00e9ligibilit\u00e9',
    fillDetails: 'Remplissez vos informations',
    fillDesc: 'Sur la base des r\u00e8gles DBR de la Banque centrale des \u00c9AE, nous calculerons le montant maximal auquel vous pouvez pr\u00e9tendre.',
    errTitle: 'Impossible de calculer l\u2019\u00e9ligibilit\u00e9',
    errDesc: 'Vos engagements actuels d\u00e9passent peut-\u00eatre la limite DBR de 50\u00a0%, ou votre \u00e2ge ne permet pas une dur\u00e9e suffisante. Contactez nos conseillers.',
    maxLoan: 'Montant maximal du pr\u00eat',
    maxProperty: 'Valeur maximale du bien',
    minDownPay: 'Apport minimal',
    maxTenure: 'Dur\u00e9e maximale',
    maxEMI: 'Mensualit\u00e9 maximale autoris\u00e9e',
    dbrTitle: 'Analyse DBR de la Banque centrale des \u00c9AE',
    grossIncome: 'Revenus mensuels bruts',
    existingObligs: 'Engagements existants',
    dbrHeadroom: 'Marge DBR (r\u00e8gle 50\u00a0%)',
    ltvApplied: 'LTV appliqu\u00e9',
    dbrNote: 'R\u00e9sultats indicatifs. L\u2019\u00e9ligibilit\u00e9 r\u00e9elle d\u00e9pend de l\u2019\u00e9valuation individuelle de la banque.',
    readyApply: 'Pr\u00eat \u00e0 postuler\u00a0?',
    readyApplyDesc: 'Nos conseillers vous obtiendront le meilleur taux aupr\u00e8s de 15+ banques des \u00c9AE.',
    talkAdvisor: 'Parler \u00e0 un conseiller \u2192',
    servicesBadge: 'Nos services',
    servicesHeading: 'Tout ce dont vous avez besoin sous un m\u00eame toit',
    servicesSub: 'Victory Homes collabore avec les principales banques des \u00c9AE pour offrir des services hypoth\u00e9caires transparents et rapides.',
    services: [
      { icon: '\ud83c\udfe0', title: 'Cr\u00e9dit immobilier r\u00e9sidentiel', desc: 'Financez la maison de vos r\u00eaves aux \u00c9AE avec des taux comp\u00e9titifs.' },
      { icon: '\u2708\ufe0f', title: 'Pr\u00eat pour non-r\u00e9sidents', desc: 'Vous vivez hors des \u00c9AE et souhaitez investir\u00a0? Nous arrangeons des pr\u00eats jusqu\u2019\u00e0 50\u00a0% LTV.' },
      { icon: '\ud83d\udd04', title: 'Rachat de cr\u00e9dit', desc: 'Payez-vous trop sur votre hypoth\u00e8que actuelle\u00a0? Changez de banque et \u00e9conomisez des milliers.' },
      { icon: '\ud83c\udfd7\ufe0f', title: 'Terrain et construction', desc: 'Produits sp\u00e9cialis\u00e9s pour financer terrains et projets de construction.' },
      { icon: '\ud83d\udccb', title: '\u00c9valuation gratuite de l\u2019\u00e9ligibilit\u00e9', desc: 'Nous \u00e9valuons votre profil et fournissons une lettre de pr\u00e9-qualification aupr\u00e8s de 5+ banques.' },
      { icon: '\ud83d\udc64', title: 'Conseiller hypoth\u00e9caire d\u00e9di\u00e9', desc: 'Chaque client b\u00e9n\u00e9ficie d\u2019un conseiller d\u00e9di\u00e9 de la demande jusqu\u2019\u00e0 la remise des cl\u00e9s.' },
    ],
    ctaHeading: 'Pr\u00eat \u00e0 franchir le cap\u00a0?',
    ctaSub: 'Nos conseillers hypoth\u00e9caires sont \u00e0 votre disposition pour vous d\u00e9crocher la meilleure offre. Consultation gratuite, sans engagement.',
    ctaBtn: 'R\u00e9server une consultation gratuite \u2192',
  },
  offplan: {
    heroBadge: '\u2726 Immobilier sur plan \u00e0 Duba\u00ef',
    heroLine1: 'Investissez avant que',
    heroAccent: 'la ville le fasse.',
    heroSub: 'Acc\u00e8s exclusif en pr\u00e9-lancement aux d\u00e9veloppements les plus pris\u00e9s de Duba\u00ef. S\u00e9curisez des unit\u00e9s de choix aux prix d\u2019aujourd\u2019hui \u2014 avant que le march\u00e9 \u00e9volue.',
    browseBtn: 'Parcourir les projets',
    advisorBtn: 'Parler \u00e0 un conseiller',
    statGrowth: 'Croissance moyenne du capital',
    statVisa: 'Seuil du visa or',
    statComm: 'Commission pour l\u2019acheteur',
    whyBadge: 'Pourquoi l\u2019immobilier sur plan',
    whyHeading: 'Le choix de l\u2019investisseur averti',
    why: [
      { icon: '\ud83d\udcb0', title: 'Prix d\u2019entr\u00e9e bas', desc: 'Achetez \u00e0 des tarifs de pr\u00e9-lancement \u2014 typiquement 20\u201330\u00a0% en dessous de la valeur march\u00e9 \u00e0 la livraison.' },
      { icon: '\ud83d\udcc5', title: 'Plans de paiement flexibles', desc: 'Les promoteurs proposent des plans 40/60 ou 20/80 \u2014 \u00e9talez votre investissement sur la p\u00e9riode de construction.' },
      { icon: '\ud83d\udcc8', title: 'Appr\u00e9ciation du capital', desc: 'L\u2019immobilier sur plan \u00e0 Duba\u00ef a historiquement offert une croissance de 30\u201350\u00a0% du lancement \u00e0 la livraison.' },
      { icon: '\ud83e\ude99', title: 'Visa or \u00e9ligible', desc: 'Les biens \u00e0 partir de 2\u00a0M AED ouvrent droit au visa or 10 ans des \u00c9AE.' },
    ],
    featuredBadge: 'Projets phares',
    featuredHeading: 'Projets sur plan s\u00e9lectionn\u00e9s',
    catalogueLink: 'Demander le catalogue complet \u2192',
    showingOf: (shown, total) => `Affichage de ${shown} sur ${total} projets`,
    noMatchTitle: 'Aucun bien correspondant trouv\u00e9',
    noMatchDesc: 'Essayez d\u2019\u00e9largir votre recherche ou de modifier les filtres.',
    clearFilters: 'Effacer tous les filtres',
    communitiesBadge: 'Explorer les communaut\u00e9s',
    communitiesHeading: 'Les quartiers les plus pris\u00e9s de Duba\u00ef',
    seeListings: 'Voir toutes les annonces \u2192',
    locations: [
      { name: 'Downtown', desc: ['Au c\u0153ur du quartier le plus ic\u00f4nique de Duba\u00ef, Downtown incarne l\u2019essence d\u2019une vie urbaine raffin\u00e9e.', 'Des lounges spacieux et des terrasses panoramiques offrant des vues imprenables sur les sites les plus c\u00e9l\u00e8bres de la ville.'] },
      { name: 'Palm Jumeirah', desc: ['Ancr\u00e9e dans le patrimoine et faonn\u00e9e par l\u2019\u00e9l\u00e9gance moderne, Palm Jum\u00e9ira est l\u2019une des adresses r\u00e9sidentielles les plus prestigieuses.', 'R\u00e9sidences con\u00e7ues avec soin et espaces ext\u00e9rieurs sereins pour un mode de vie confort et priv\u00e9.'] },
      { name: 'Marina', desc: ['Longeant le littoral scintillant de Duba\u00ef, la Marina conjugue l\u2019\u00e9nergie de la ville et l\u2019\u00e9l\u00e9gance balnaire.', 'Marinas priv\u00e9es, promenades pittoresques et terrasses panoramiques avec vue sur l\u2019eau.'] },
      { name: 'Dubai Hills', desc: ['Au c\u0153ur de Duba\u00ef, Dubai Hills red\u00e9finit la vie moderne par une fusion harmonieuse de nature et de sophistication urbaine.', 'Un cadre de vie all\u00e9ant bien-\u00eatre, \u00e9l\u00e9gance et esprit communautaire.'] },
      { name: 'Arabian Ranches', desc: ['Cers villas \u00e9l\u00e9gantes, rues bord\u00e9es d\u2019arbres et espaces ouverts font de la vie ici un havre de paix et de volupte.', 'Jardins paysag\u00e9s, parcs communautaires et golfs pour une vie de famille \u00e9panouie.'] },
    ],
  },
  sell: {
    heroBadge: 'Publier votre bien',
    heroHeadline: 'Associez-vous à',
    heroAccent: 'Victory Homes',
    heroSub: 'Publiez votre bien avec notre équipe d\'experts pour la vente ou la location. Nous gérons tout, de l\'estimation à la conclusion.',
    formBadge: 'Pour les propriétaires',
    formHeading: 'Publiez votre bien avec nous',
    formSub: 'Remplissez le formulaire et notre équipe gérera tout — de l\'estimation à la conclusion.',
    tabSell: '🏷️ Vendre',
    tabRent: '🔑 Louer',
    sectionContact: 'Coordonnées',
    sectionProperty: 'Détails du bien',
    sectionDocs: 'Documents juridiques',
    sectionPhotos: 'Photos du bien',
    fullName: 'Nom complet',
    email: 'Adresse e-mail',
    phone: 'Numéro de téléphone',
    whatsapp: 'WhatsApp (optionnel)',
    propertyType: 'Type de bien',
    selectType: '— Sélectionnez le type —',
    emirate: 'Émirat',
    selectEmirate: '— Sélectionnez l\'Émirat —',
    community: 'Résidence / Zone',
    subCommunity: 'Sous-résidence / Bâtiment',
    bedrooms: 'Chambres',
    bathrooms: 'Salles de bain',
    select: '— Sélectionner —',
    areaSqFt: 'Surface (piéds carrés)',
    floor: 'Étage',
    furnishing: 'Ameublement',
    completion: 'État d\'achèvement',
    ready: 'Prêt',
    offPlan: 'Sur plan',
    askingPrice: 'Prix demandé',
    rentAmount: 'Loyer (par an)',
    priceHint: 'Entrez le montant sans virgule. Le prix doit refléter la valeur marché actuelle.',
    youtubeLink: 'Lien vidéo YouTube',
    youtubeHint: 'Ajoutez un lien YouTube pour présenter votre propriété (optionnel)',
    description: 'Description du bien',
    descPlaceholder: 'Décrivez votre bien — caractéristiques, vues, aménagements, commodités proches…',
    docsIntro: 'Ces documents attestent de la propriété et facilitent la publication. Tous les fichiers sont sécurisés.',
    titleDeed: 'Titre de propriété',
    titleDeedHint: 'Titre officiel délivré par l\'autorité compétente.',
    floorPlan: 'Plan de sol',
    floorPlanHint: 'Plan architectural. PDF ou image de préférence.',
    passport: 'Copie du passeport',
    passportHint: 'Passeport valide du propriétaire du bien.',
    privacy: 'Confidentialité garantie. Vos documents sont chiffrés et accessibles uniquement à notre équipe autorisée.',
    photosLabel: 'Photos du bien',
    photosHint: 'Jusqu\'à 20 images — JPG, PNG, WEBP. La première image sera la couverture.',
    photosIntro: 'De bonnes photos augmentent considérablement les demandes. Utilisez des prises de vue lumineuses et grand-angle.',
    dragDrop: 'Glissez & déposez ou',
    browse: 'parcourir',
    accepted: 'PDF, JPG, PNG acceptés',
    clickReplace: 'Cliquer pour remplacer',
    dropPhotos: 'Déposer les photos ici',
    orClickBrowse: 'ou cliquer pour parcourir',
    upTo20: 'Jusqu\'à 20 images',
    photosAdded: (n) => `${n} photo${n > 1 ? 's' : ''} ajouté${n > 1 ? 'es' : 'e'}`,
    submitSale: '🚀 Soumettre l\'annonce de vente',
    submitRental: '🚀 Soumettre l\'annonce de location',
    submitting: '⏳ Envoi en cours…',
    termsNotice: 'En soumettant, vous acceptez les Conditions d\'utilisation de Victory Homes.',
    successTitle: 'Annonce soumise !',
    successDesc: 'Notre équipe examinera et vous contactera dans les',
    successHours: '24 heures',
    submitAnother: 'Soumettre une autre',
    errName: 'Le nom complet est requis',
    errEmail: 'E-mail valide requis',
    errPhone: 'Numéro de téléphone requis',
    errPropType: 'Sélectionnez le type de bien',
    errEmirate: 'Sélectionnez l\'Émirat',
    errPrice: 'Le prix demandé est requis',
    errRent: 'Le loyer est requis',
    errPhotos: 'Au moins une photo est requise',
  },
  props: {
    heroBadge: 'Propriétés aux ÉAE',
    listingCount: (n) => `${n} annonce${n > 1 ? 's' : ''} disponible${n > 1 ? 's' : ''}`,
    tabBuy: 'Acheter',
    tabRent: 'Louer',
    portfolio: 'Notre portefeuille',
    forSale: 'Propriétés à vendre',
    forRent: 'Propriétés à louer',
    listYourProperty: 'Publier votre bien →',
    buy: {
      badge: 'Propriétés à vendre',
      headline: 'Trouvez votre',
      accent: 'bien idéal à acheter',
      sub: 'Découvrez des annonces de vente vérifiées sélectionnées par nos experts à travers les ÉAE.',
    },
    rent: {
      badge: 'Propriétés à louer',
      headline: 'Trouvez votre',
      accent: 'bien idéal à louer',
      sub: 'Parcourez des annonces de location de qualité à Dubaï et dans les Émirats, sélectionnées par Victory Homes.',
    },
    enquireNow: 'Demander maintenant →',
    noMatchTitle: 'Aucune annonce ne correspond à vos filtres',
    noMatchDesc: 'Essayez d\'ajuster votre budget, le type ou la zone.',
    clearFilters: 'Effacer tous les filtres',
    emptyBuy: 'Aucun bien actuellement à vendre',
    emptyRent: 'Aucun bien actuellement à louer',
    emptyDesc: () => 'Notre portefeuille est régulièrement mis à jour — revenez bientôt ou contactez-nous directement.',
    speakAgent: 'Parler à un agent →',
    listProp: 'Publier votre bien',
    exploreOther: 'Explorer d\'autres biens',
    otherForSale: 'Autres biens disponibles à vendre',
    otherForRent: 'Autres biens disponibles à louer',
    otherDesc: 'Voici d\'autres biens de notre portefeuille qui pourraient vous intéresser.',
    ctaBadge: 'Prêt à publier ?',
    ctaHeading: 'Vous avez un bien à publier ?',
    ctaDesc: 'Nos courtiers experts gèrent tout, de l\'estimation à la conclusion. Publiez votre bien avec Victory Homes aujourd\'hui.',
    contactUs: 'Nous contacter',
  },
  featured: {
    tag: 'Propriétés exclusives',
    heading: 'Explorez les propriétés exclusives avec Emirates',
    desc: 'Découvrez la meilleure sélection de maisons luxueuses et d\'opportunités immobilières avec Emirates. Entrez dans le style de vie que vous méritez.',
  },
  partners: {
    tag: 'Nos partenaires',
    heading: 'Propriétés des meilleurs promoteurs des Émirats',
    learnMore: 'En savoir plus',
    learnMoreArrow: 'En savoir plus →',
    oasis: { title: 'Oasis Garden Villas', desc: 'Maisons contemporaines spacieuses avec jardins privés, cours ombragées et aménagements inspirés de la nature — conçues pour la sérénité et la vie en famille.' },
    ghaf:  { title: 'Ghaf Woods, Dubaï', desc: 'Quartier résidentiel à faible densité avec des maisons éco-responsables et des espaces verts abondants — conçu pour le bien-être et la vie à long terme.' },
    nad:   { title: 'Nad Al Sheba', desc: 'Quartier résidentiel exclusif avec de spacieuses villas dans un environnement paisible, réputé pour son intimité, sa verdure et sa proximité des sites clés de Dubaï.' },
    district: { title: 'District One, Dubaï', desc: 'Communauté ultra-luxueuse avec d\'élégantes villas et des manoirs autour de lagons cristallins et de verdure luxuriante — conçue pour l\'intimité et le prestige.' },
  },
  media: {
    tag: 'Couverture médiatique',
    heading: 'Mis en lumière dans la presse',
    readArticle: 'Lire l\'article',
  },
  newsletter: {
    badge: 'Restez informé',
    heading: 'Gardez une longueur d\'avance sur le marché immobilier de Dubaï',
    desc: 'Recevez des annonces exclusives, des analyses de marché et des opportunités d\'investissement dans votre boîte mail — avant qu\'ils n\'arrivent sur le marché.',
    placeholder: 'Entrez votre adresse e-mail',
    btn: 'S\'abonner →',
    privacy: '🔒 Pas de spam. Désabonnement à tout moment. Vos données sont protégées.',
    success: '✓ Vous êtes abonné(e) ! Bienvenue dans la communauté Victory Homes.',
    error: 'Veuillez entrer une adresse e-mail valide.',
  },
  nav: {
    home: 'Accueil', properties: 'Propriétés', buy: '🏡 Acheter', rent: '🔑 Louer',
    sellRent: 'Vendre/Louer', offplan: 'Sur Plan', services: 'Services',
    holidayHomes: 'Maisons de Vacances', propertyManagement: 'Gestion Immobilière',
    fitOut: 'Aménagement, Déménagement et Emballage',
    legalAssistance: 'Assistance Juridique',
    valuation: 'Évaluation Immobilière',
    calculators: 'Crédit immobilier',
    transactions: 'Transactions',
    mortgage: 'Calculateur de prêt immobilier', contact: 'Nous contacter', roiCalc: 'Calculateur ROI',
    areaIntelligence: 'Intelligence des Zones',
  },
  valuation: {
    heroTitle: 'Évaluation Immobilière Gratuite',
    heroDesc: 'Vous pensez à vendre ? Obtenez une évaluation instantanée et basée sur les données du marché actuel de votre propriété.',
    successTitle: 'Demande Reçue !',
    successDesc: 'Nos experts examineront les détails de votre propriété et vous contacteront sous peu.',
    submitAnother: 'Soumettre une autre demande',
    fullName: 'Nom Complet *',
    phone: 'Numéro de Téléphone *',
    email: 'Adresse E-mail',
    propType: 'Type de Propriété *',
    selectType: 'Sélectionner le type',
    location: 'Emplacement / Communauté *',
    locPlaceholder: 'ex: Dubai Marina',
    bedrooms: 'Chambres',
    select: 'Sélectionner',
    area: 'Surface bâtie (Sq.Ft)',
    areaPlaceholder: 'ex: 1500',
    submit: 'Obtenir Mon Évaluation Gratuite',
    submitting: 'Envoi en cours...',
    fail: 'Échec de lenvoi. Veuillez réessayer.'
  },
  recentlySold: {
    title: 'Propriétés Récemment Vendues',
    desc: 'Une sélection de nos dernières transactions réussies. Découvrez la différence Victory Homes.',
    badge: 'Vendu',
    beds: 'Lits'
  },
  trust: {
    clientStories: 'Histoires de Clients',
    hearFromClients: 'Écoutez nos clients',
    videoUnavailable: 'Vidéo Indisponible',
    trackRecord: 'Bilan',
    provenSuccess: 'Succès Prouvé'
  },
  areaIntelligence: {
    heroBadge: 'Intelligence des Zones de Dubaï',
    heroLine1: 'Analyses fondées sur les données pour',
    heroAccent: 'Chaque Quartier de Dubaï.',
    heroSub: "Explorez les tendances de prix, les rendements locatifs et les analyses d'investissement IA dans les communautés les plus prisées de Dubaï.",
    modeBuy: 'Acheter',
    modeRent: 'Louer',
    modeOffplan: 'Sur Plan',
    filterTitle: 'Filtres et Métriques',
    heatmapLabel: 'Métrique de la Carte',
    chartAreasLabel: 'Zones des Graphiques',
    selectAll: 'Tout',
    selectNone: 'Aucun',
    loading: 'Chargement des données de zone…',
    mapsKeyMissing: 'Clé API Google Maps Requise',
    mapsKeyHint: 'Ajoutez VITE_GOOGLE_MAPS_API_KEY à votre fichier .env, puis rechargez.',
    mapFailedLoad: 'Échec du chargement de la carte. Vérifiez votre clé API.',
    mapLoading: 'Chargement de la carte…',
    legendSelectedArea: '⬤ Zone sélectionnée',
    legendSelectedDesc: 'Bulle blanche = votre sélection active',
    legendLow: { avgPrice: 'Prix bas', rentalYield: 'Rendement bas', demandScore: 'Faible demande', avgPricePerSqft: 'Prix/pi² bas' },
    legendHigh: { avgPrice: 'Prix élevé', rentalYield: 'Rendement élevé', demandScore: 'Forte demande', avgPricePerSqft: 'Prix/pi² élevé' },
    activeProjects: 'Projets actifs',
    nearbyLandmarks: '📍 Sites à proximité',
    kpiAvgPrice: 'Prix moyen',
    kpiPricePerSqft: 'Prix / pi²',
    kpiGrossYield: 'Rendement brut',
    kpiDemandScore: 'Indice de demande',
    aiInsightTitle: '✦ Analyse IA du marché',
    aiGenerate: 'Générer →',
    aiAnalysing: 'Analyse des données du marché…',
    aiKeyMissing: 'Ajoutez GEMINI_API_KEY à backend/.env pour activer les analyses IA.',
    aiPrompt: 'Cliquez sur "Générer" pour une analyse d\'investissement IA sur cette zone.',
    browseOffplan: (name) => `Explorer l'offplan à ${name} →`,
    viewResale: 'Voir les biens en revente →',
    priceTrendBadge: 'Tendance des prix',
    priceTrendTitle: 'Prix sur 12 mois par pi² (AED)',
    priceTrendSub: 'Tendance sur 12 mois basée sur les données agrégées du marché',
    rentalYieldBadge: 'Rendement locatif',
    rentalYieldTitle: 'Rendement locatif brut par zone (%)',
    rentalYieldSub: 'Basé sur le loyer annuel moyen vs le prix d\'achat moyen',
    tooltipYield: (val, name) => [`${val}% rendement brut`, name],
    comparisonBadge: 'Comparaison des zones',
    comparisonTitle: 'Comparer jusqu\'à 3 zones',
    comparisonSub: 'Sélectionnez des zones ci-dessous pour les comparer côte à côte',
    comparisonPlaceholder: 'Sélectionnez des zones ci-dessus pour voir la comparaison',
    colMetric: 'Métrique',
    rowAvgPrice: 'Prix moyen',
    rowPricePerSqft: 'Prix / pi²',
    rowGrossYield: 'Rendement brut',
    rowDemandScore: 'Indice de demande',
    rowActiveProjects: 'Projets actifs',
    rowMinEntry: 'Prix d\'entrée min.',
    rowMaxPrice: 'Prix max.',
    best: 'Meilleur',
    metricAvgPrice: 'Prix moyen',
    metricRentalYield: 'Rendement locatif',
    metricDemand: 'Demande',
    metricPricePerSqft: 'Prix/pi²',
  },
  hero: {
    slide1H: 'Là où données intelligentes, conseils personnalisés et confiance se rejoignent.',
    slide1P: 'Victory Homes est le premier courtier des Émirats qui aide les gens à découvrir la vie qu\'ils souhaitent avant de trouver la maison dont ils ont besoin.',
    slide1Btn: 'Découvrir',
    slide2H: 'Propriétés en bord de mer exclusives.',
    slide2P: 'Découvrez un luxe incomparable sur l\'île artificielle la plus emblématique du monde à Palm Jumeirah.',
    slide2Btn: 'Explorer Palm',
    slide3H: 'La vie du futur, parfaitement adaptée.',
    slide3P: 'Grâce aux données environnementales et à la modélisation prédictive, nous connectons les personnes aux communautés avant-gardistes de Dubai Marina.',
    slide3Btn: 'Découvrir Marina',
    slide4H: 'Trouvez la vie, pas seulement la maison.',
    slide4P: 'Découvrez un sanctuaire privé entouré du légendaire Crystal Lagoon et de vastes espaces verts à District One.',
    slide4Btn: 'Voir District One',
  },
  stats: {
    impact: 'Notre impact commercial',
    sold: 'Total vendu 2020–2024',
    lifetime: 'Volume de ventes cumulé',
    current: 'Volume d\'annonces actuelles',
  },
  sellTestimonials: {
    tag: 'Témoignages',
    heading: 'Vendez avec Victory Homes — vite et efficacement',
    desc: 'Un processus fluide et transparent pour maximiser la valeur de votre bien tout en réduisant votre stress.',
  },
  team: {
    tag: 'L\'Équipe',
    heading: 'Rencontrez les meilleurs experts immobiliers des Émirats',
    desc: 'Nos agents dévoués chez Victory Homes sont des professionnels expérimentés prêts à vous guider à chaque étape.',
    btn: 'Rencontrer toute l\'équipe →',
  },
  goldenVisa: {
    badge: '🇦🇪 Avantage investisseur',
    heading: 'Visa Doré des Émirats',
    headingGold: 'Via l\'immobilier',
    desc: 'Investissez dans l\'immobilier des Émirats pour <strong>2 000 000 AED ou plus</strong> et obtenez un <strong>visa de résidence renouvelable de 10 ans</strong> — pour vous et votre famille.',
    cta: 'Vérifier mon éligibilité →',
    benefitsHeading: 'Pourquoi le Visa Doré change la donne',
    benefitsSubheading: 'Le Visa Doré des Émirats ouvre des portes que la plupart des pays n\'offrent tout simplement pas.',
    stepsHeading: 'Comment obtenir votre Visa Doré',
    stepsSubheading: '4 étapes simples — notre équipe vous guide à chaque étape',
    stepCtaHeading: 'Prêt à obtenir votre Visa Doré des Émirats ?',
    stepCtaDesc: 'Nos conseillers identifieront la propriété qualifiante adaptée à votre budget.',
    stepCtaBtn: 'Parler à un conseiller',
    yearVisa: 'Ans de visa',
    minValue: 'Valeur minimale du bien',
    benefits: {
      b1t: 'Résidence de 10 ans', b1d: 'Obtenez un Visa Doré en investissant dans un bien d\'une valeur de 2 millions AED ou plus.',
      b2t: 'Parrainage familial', b2d: 'Parrainer votre conjoint, vos enfants et vos parents sous le même visa.',
      b3t: 'Sans sponsor requis', b3d: 'Vivez, travaillez et étudiez aux Émirats sans avoir besoin d\'un employeur ou d\'un sponsor local.',
      b4t: 'Renouvelable indéfiniment', b4d: 'Tant que vous détenez le bien qualifiant, le Visa Doré se renouvelle automatiquement.',
      b5t: 'Mobilité mondiale', b5d: 'Profitez d\'entrées multiples et de séjours prolongés hors des Émirats sans perdre la validité.',
      b6t: 'Sécurité de l\'investissement', b6d: 'L\'immobilier des Émirats est un actif de premier rang — combinez résidence d\'élite et forte plus-value.',
    },
    steps: {
      s1: 'Acquérir un bien d\'une valeur d\'au moins 2 M AED',
      s2: 'Obtenir le titre de propriété auprès du Département foncier de Dubaï',
      s3: 'Déposer la demande via l\'ICA ou le GDRFA avec l\'aide de notre équipe',
      s4: 'Recevoir votre Visa Doré de 10 ans et votre Emirates ID',
    },
  },
  blog: {
    tag: 'Le Blog',
    heading: 'Analyses et actualités du blog immobilier des Émirats',
    desc: 'Découvrez les dernières nouvelles du marché, des conseils et les analyses d\'experts sur l\'immobilier de Dubaï.',
    readMore: 'Continuer la lecture',
  },
  evo: {
    statsBadge: 'Dubaï en chiffres',
    statsHeading: "L'évolution de l'immobilier à Dubaï",
    statsDesc: "D'un port commercial régional au marché immobilier le plus dynamique du monde en deux décennies.",
    timelineBadge: "L'Histoire",
    timelineHeading: 'Comment Dubaï est devenu la 1ère destination immobilière mondiale',
    timelineCTA: 'Vous voulez comprendre où va le marché de Dubaï ?',
    timelineBtn: 'Parler à un expert du marché →',
    stats: {
      s1l: 'Transactions immobilières en 2024', s2l: 'Valeur totale des ventes en AED 2024',
      s3l: 'Croissance des prix depuis 2020', s4l: 'Nationalités vivant à Dubaï',
    },
    timeline: {
      t1t: 'Loi sur la pleine propriété', t1d: 'Dubaï permet aux étrangers de posséder des biens dans des zones franches — déclenchant la première vague d\'investissement.',
      t2t: 'Transformation de la skyline', t2d: 'Le Burj Khalifa ouvre. Dubaï devient la ville moderne la plus reconnaissable au monde.',
      t3t: 'Lancement du Visa Doré', t3d: 'Les Émirats lancent le programme de Visa Doré de 10 ans, boostant la demande pour les biens à 2M AED+.',
      t4t: 'Marché record', t4d: 'La reprise post-pandémie entraîne une hausse sans précédent de plus de 60 % des prix.',
      t5t: 'Nouveaux records historiques', t5d: 'Dubaï enregistre plus de 96 000 transactions d\'une valeur de 411 milliards AED.',
      t6t: 'Plan urbain Dubaï 2040', t6d: 'Le plan vise à doubler les espaces verts et atteindre 5,8 millions d\'habitants d\'ici 2040.',
    },
  },
  txn: {
    badge: 'Propulsé par DXBinteract',
    heading: 'Rapports de transactions à Dubaï',
    desc: 'Accédez aux données en direct du Département foncier de Dubaï — chaque vente enregistrée, chaque prix suivi.',
    live: 'Données DLD en direct',
    openPlatform: 'Ouvrir la plateforme ↗',
    viewReport: 'Voir le rapport →',
    ctaHeading: 'Vous souhaitez un rapport personnalisé pour une zone spécifique ?',
    ctaDesc: 'Nos conseillers peuvent extraire des données et les interpréter pour votre investissement.',
    ctaBtn: 'Interroger un conseiller',
    reports: {
      r1l: 'Rapport quotidien', r1d: 'Chaque transaction DLD — mise à jour quotidienne.',
      r2l: 'Rapport hebdomadaire', r2d: 'Résumé hebdomadaire: volumes, prix et tendances par zone.',
      r3l: 'Rapport mensuel', r3d: 'Analyse approfondie des performances mensuelles par type de bien.',
      r4l: 'Rapport trimestriel', r4d: 'Analyse trimestrielle: variations de prix, zones phares, activité des investisseurs.',
      r5l: 'Rapport annuel', r5d: 'Bilan annuel du marché: transactions record, nouvelles communautés, prévisions.',
      r6l: 'Carte des prix par zone', r6d: 'Carte thermique interactive du prix au pied carré dans toutes les communautés de Dubaï.',
    },
  },
  cta: {
    buying: 'Commencer à acheter', selling: 'Commencer à vendre', contact: 'Nous contacter',
    findOut: 'En savoir plus', comingSoon: 'Bientôt disponible',
  },
  offplanPromo: {
    badge: 'Propriétés sur plan',
    heading: 'Nouveaux projets et offres exclusives de prélancement',
    desc: 'Réservez des unités dans les meilleurs projets sur plan de Dubaï — avant qu\'ils ne soient vendus. Éligible au Visa Doré dès 2M AED.',
    btn: 'Explorer l\'offplan →',
  },
  topCommunities: {
    badge: 'Aperçus du Marché',
    heading: 'Top des Communautés à Dubaï',
    desc: 'Aperçus stratégiques pour les investisseurs et utilisateurs finaux (2026-2027)',
    tabs: {
      roi: 'Leaders du ROI',
      villas: 'Villas & Maisons de Ville',
      budget: 'Par Budget',
      strategy: 'Guide Stratégique'
    },
    roi: {
      title: 'Meilleures Communautés pour le ROI (2026–2027)',
      desc: 'Ces zones offrent régulièrement de forts rendements locatifs et une plus-value sur le capital.',
      list: [
        'Jumeirah Village Circle',
        'Dubai South',
        'Arjan',
        'Dubai Silicon Oasis',
        'Dubai Sports City',
        'Business Bay',
        'Dubai Marina'
      ],
      insightTitle: 'Point Clé',
      insights: [
        'JVC + Arjan = meilleurs rendements (6–9%)',
        'Marina + Business Bay = rendement inférieur mais forte plus-value + liquidité'
      ]
    },
    villas: {
      title: 'Meilleures Communautés de Villas / Maisons de Ville',
      desc: 'Idéal pour les utilisateurs finaux, les familles et la vie à long terme.',
      list: [
        'Dubai Hills Estate',
        'Arabian Ranches',
        'Tilal Al Ghaf',
        'DAMAC Hills',
        'The Valley',
        'Mudon',
        'Town Square'
      ],
      insightTitle: 'Point Clé',
      insights: [
        'Dubai Hills = meilleur équilibre (emplacement + qualité)',
        'Tilal Al Ghaf = communauté style de vie premium',
        'Town Square / Valley = villas d\'entrée de gamme'
      ]
    },
    budget: {
      title: 'Meilleures Communautés par Budget',
      categories: [
        {
          name: 'Entrée de Gamme',
          range: '500 000 – 900 000 AED',
          areas: ['International City', 'Dubai South', 'Discovery Gardens', 'Dubai Production City', 'Liwan'],
          bestFor: 'premiers investisseurs, rendement locatif maximum'
        },
        {
          name: 'Milieu de Gamme',
          range: '900 000 – 2 Millions AED',
          areas: ['Jumeirah Village Circle', 'Arjan', 'Al Furjan', 'Dubai Silicon Oasis', 'Dubai Creek Harbour'],
          bestFor: 'équilibre entre ROI + appréciation'
        },
        {
          name: 'Haut de Gamme / Premium',
          range: '2 Millions – 5 Millions AED',
          areas: ['Business Bay', 'Dubai Marina', 'Dubai Hills Estate', 'Palm Jumeirah (unités d\'entrée)'],
          bestFor: 'liquidité + forte demande à la revente'
        },
        {
          name: 'Luxe',
          range: '5 Millions+ AED',
          areas: ['Downtown Dubai', 'Palm Jumeirah', 'Emirates Hills', 'District One', 'Jumeirah Bay Island'],
          bestFor: 'préservation du capital + actifs de prestige'
        }
      ]
    },
    strategy: {
      title: 'Guide Stratégique Simple',
      guide: [
        { goal: 'ROI maximum', action: 'JVC, Arjan, Dubai South' },
        { goal: 'investissement sûr', action: 'Dubai Hills, Marina' },
        { goal: 'appréciation luxe', action: 'Palm Jumeirah, Downtown' },
        { goal: 'vie de famille', action: 'Arabian Ranches, Tilal Al Ghaf' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "Services Victory",
    "whyChoose": "Pourquoi choisir notre {service} ?",
    "form": {
        "fullName": "Nom Complet",
        "email": "Adresse Email",
        "phone": "Numéro de Téléphone",
        "detailsOpt": "Détails de la Propriété (Optionnel)",
        "messageOpt": "Message ou Demandes Supplémentaires",
        "submitRequest": "Soumettre la Demande",
        "submitting": "Envoi en cours...",
        "successTitle": "Demande Reçue !",
        "successDesc": "Merci de nous avoir contactés pour notre {service}. Notre équipe va examiner votre demande et vous répondra sous peu.",
        "submitAnother": "Soumettre une autre demande",
        "errors": {
            "nameReq": "Veuillez entrer votre nom complet",
            "emailReq": "Veuillez entrer une adresse email valide",
            "phoneReq": "Veuillez entrer votre numéro de téléphone",
            "failSub": "Échec de la soumission. Veuillez réessayer plus tard."
        },
        "placeholders": {
            "name": "ex: Jean Dupont",
            "email": "vous@exemple.com",
            "phone": "+971 50 123 4567",
            "details": "ex: Appartement 2 chambres à Downtown Dubai",
            "message": "Comment pouvons-nous vous aider ?"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "Maisons de Vacances",
            "heroSub": "Maximisez le rendement de votre propriété avec notre gestion premium.",
            "desc": "Transformez votre propriété en location de vacances lucrative sans tracas. Nous gérons le marketing, l'accueil et l'entretien.",
            "extraDesc": "De l'ameublement à la photographie professionnelle jusqu'aux annonces optimisées, notre stratégie assure une occupation maximale avec un support client 24/7.",
            "points": [
                "Tarification Dynamique et Marketing",
                "Assistance aux Invités et Conciergerie 24/7",
                "Entretien Ménager Professionnel",
                "Rapports de Rendement Mensuels",
                "Assistance Juridique et Inscription"
            ],
            "formTitle": "Demande de Gestion de Maisons de Vacances",
            "formDesc": "Indiquez-nous comment nous pouvons vous aider avec vos objectifs de location."
        },
        "property-management": {
            "title": "Gestion Immobilière",
            "heroSub": "Des services de gestion complets pour votre tranquillité d'esprit.",
            "desc": "Du filtrage des locataires aux demandes d'entretien, notre équipe dévouée gère vos investissements en toute sécurité.",
            "extraDesc": "Nous gérons tout : l'enregistrement Ejari, la collecte des loyers, les inspections régulières et les réparations urgentes.",
            "points": [
                "Filtrage Complet des Locataires",
                "Collecte des Loyers et Rapports Financiers",
                "Ejari et Conformité Juridique",
                "Inspections de Routine et Entretien",
                "Services de Résolution de Conflits"
            ],
            "formTitle": "Demander un service de Gestion",
            "formDesc": "Fournissez vos coordonnées pour un plan de gestion sur mesure."
        },
        "fit-out": {
            "title": "Aménagement et Réhabilitation",
            "heroSub": "Transformez votre espace avec nos solutions d’aménagement intérieur de classe mondiale.",
            "desc": "Conception et exécution sur mesure pour espaces résidentiels et commerciaux. Qu'il s'agisse d'une villa ou d'un bureau.",
            "extraDesc": "Nos designers travaillent de concert avec vous depuis la conception initiale jusqu'à l'achèvement avec des matériaux haut de gamme et conformité réglementaire.",
            "points": [
                "Concepts de Design Intérieur Sur Mesure",
                "Planification et Visualisation 3D",
                "Exécution Clés en Main et Gestion de Projet",
                "Permis et Approbations Officielles",
                "Sourcing Matériaux et Ameublement"
            ],
            "formTitle": "Planifier une Consultation Réhabilitation",
            "formDesc": "Programmez une consultation pour discuter de votre vision."
        },
        "legal-assistance": {
          title: "Assistance Juridique",
          heroSub: "Conseils juridiques experts pour des transactions immobilières sécurisées aux EAU.",
          desc: "Naviguer dans les lois immobilières de Dubaï nécessite de la précision. Nous fournissons un soutien juridique complet pour garantir des transactions sans stress.",
          extraDesc: "De la vérification minutieuse des titres à la garantie dune conformité totale avec la RERA, nos experts protègent vos intérêts.",
          points: ["Vérification des Titres & Diligence Raisonnable", "Conformité RERA", "Préparation de lActe de Vente", "Vérification de lAchat Immobilier", "Résolution de Litiges"],
          formTitle: "Demander une Assistance Juridique",
          formDesc: "Fournissez vos coordonnées et nos experts juridiques vous contacteront."
        }
    }
},
  footer: {
    letsWork: 'Travaillons ensemble',
    email: 'E-mail',
    callWhatsApp: 'Appel / WhatsApp',
    ourLocation: 'Notre emplacement',
    officePhone: 'Téléphone du bureau',
    tagline: 'Votre partenaire immobilier de confiance à Dubaï. Spécialisés dans l\'achat, la vente et la location de propriétés premium aux Émirats.',
    ourServices: 'Nos services',
    usefulLinks: 'Liens utiles',
    copyright: '© 2025 Victory Homes. Tous droits réservés.',
    serviceLinks: ['Nouvelles propriétés', 'Vendre votre bien', 'Nos services', 'Communiqué de presse'],
    headline: 'Notre équipe d\'agents immobiliers qualifiés est prête et disponible à tout moment, n\'importe où.',
  },
  offplanDetail: {
    overview: "Aperçu",
    propertyTypes: "Types de propriétés",
    totalUnits: "Total des unités",
    handover: "Remise",
    startingPrice: "Prix de départ",
    startingFrom: "À partir de",
    paymentPlan: "Plan de paiement",
    location: "Emplacement et connectivité",
    mins: "Mins",
    unitType: "Type d'unité",
    size: "Taille",
    availableOptions: "Options disponibles",
    getBrochure: "Obtenir la brochure",
    reqDetails: "Demander des détails",
    dlBrochure: "Télécharger la brochure",
    dlFloorPlans: "Télécharger les plans",
    fullName: "Nom complet *",
    emailAdd: "Adresse Email *",
    phoneNum: "Numéro de téléphone",
    reqDesc: "Remplissez vos coordonnées pour recevoir le {type} complet du projet pour {name}.",
    reqSuccess: "Demande reçue",
    reqSuccessDesc: "Merci. Un de nos spécialistes vous enverra bientôt la brochure et les plans par email.",
    close: "Fermer",
    submitting: "Soumission...",
    reqType: "Demander {type}",
    types: {
        Apartment: "Appartement",
        Townhouse: "Maison de ville",
        Villa: "Villa",
        Penthouse: "Penthouse",
        Mansion: "Manoir",
        Duplex: "Duplex",
        Plot: "Terrain"
    },
    tags: {
        waterfront: "Bord de l'eau",
        family: "Famille",
        luxury: "Luxe",
        investment: "Investissement",
        golf: "Golf",
        urban: "Urbain",
        nature: "Nature"
    },
    beds: {
        studio: "Studio",
        br: "Ch.",
        units: "Unités",
        various: "Divers"
    }
}
,
  offplanExtra: {
        "interested": "Intéressé(e) ?",
        "readyToSecure": "Prêt à sécuriser votre unité à",
        "advisorGuide": "Nos conseillers spécialisés peuvent vous guider sur les prix, les options de paiement et le processus d'achat complet — sans commission.",
        "getInTouch": "Contactez-nous",
        "whatsapp": "WhatsApp",
        "enquire": "Se renseigner",
        developer: "Développeur",
    community: "Communauté",
    buildingHeight: "Hauteur du bâtiment",
    retailSpace: "Espace de vente",
    furnishing: "Ameublement",
    about: "À propos de",
    investmentOutlook: "Perspectives d'investissement",
    lifestyle: "Mode de vie",
    worldClassAmenities: "Équipements de classe mondiale",
    unitTypes: "Types d'unités",
    floorPlans: "Plans d'étage",
    financing: "Financement",
    typesSuffix: "Types",
    sizeRange: "Superficie",
    units: "Unités",
    from: "À partir de",
        ofTotalPayment: "du paiement total",
        whyOffPlan: "Pourquoi sur plan ?",
        lowerEntryPrice: "Prix d'entrée inférieur aux propriétés achevées",
        spreadPayments: "Étaler les paiements pendant la construction",
        capitalAppreciation: "Plus-value avant la livraison",
        zeroCommission: "0% de commission — achat direct",
        speakToAdvisor: "Parler à un conseiller",
        openMap: "Ouvrir l'emplacement exact dans Google Maps",
        nearbyPlaces: "Lieux à proximité",
        to: "vers",
        booking: "Réservation",
        installment: "Acompte",
        handover: "Remise des clés",
        areaUnit: "Unité de surface",
        currency: "Devise",
        youtubeLink: "Lien vidéo YouTube",
        watchVideo: "Regarder la vidéo",
        watchTour: "Regarder la visite"
    },
  amenities: {
        "Kids Pool": "Piscine pour enfants",
        "Private Beach Access": "Accès plage privée",
        "Marina Access": "Accès marina",
        "Outdoor Gym": "Gymnase en plein air",
        "Basketball Court": "Terrain de basket",
        "Tennis Court": "Court de tennis",
        "Padel Court": "Terrain de padel",
        "Cycling Track": "Piste cyclable",
        "Spa & Wellness Center": "Spa et centre de bien-être",
        "Kids Play Area": "Aire de jeux pour enfants",
        "Clubhouse": "Clubhouse",
        "Library": "Bibliothèque",
        "Retail Outlets": "Boutiques de détail",
        "Cafes & Restaurants": "Cafés et restaurants",
        "Supermarket": "Supermarché",
        "Concierge Service": "Service de conciergerie",
        "24/7 Security": "Sécurité 24/7",
        "CCTV Surveillance": "Surveillance CCTV",
        "Mosque": "Mosquée",
        "Pet Friendly": "Animaux acceptés",
        "Dining Destinations": "Destinations gastronomiques",
        "Yoga Studio": "Studio de yoga",
        "Lush Green Parks": "Parcs verdoyants",
        "Valet Parking": "Service de voiturier",
        "Smart Home Features": "Caractéristiques de maison intelligente",
        "Sauna & Steam Room": "Sauna et hammam",
        "Covered Parking": "Parking couvert",
        "Landscaped Gardens": "Jardins paysagers",
    "Swimming Pool": "Piscine",
    "State-of-the-art Gym": "Gymnase ultramoderne",
    "BBQ Area": "Espace barbecue",
    "Sports Courts": "Terrains de sport",
    "Infinity Pool": "Piscine à débordement",
    "Running Track": "Piste de course",
    "Cinema Room": "Salle de cinéma",
    "Games Room": "Salle de jeux"
}
}

export default fr
